import React from "react";
import { List, Datagrid, TextField, EmailField, DateField, FunctionField, usePermissions, TopToolbar, ExportButton } from "react-admin";
import { downloadCSV } from 'react-admin';
import { unparse } from 'papaparse';
import CustomCreateButton from "../components/CustomeCreateButton";

const customExporter = (records) => {
  // エクスポートするデータをカスタムフォーマットに変換
  const csvData = records.map(record => ({
    "ユーザーネーム": `${record.userName ?? ""}`, 
    "名前": `${record.name ?? ""}`, // フルネーム結合
    "メール": record.mail ?? "",
    "権限": record.userType ? getType(record.userType) : "",
    "登録日": new Date(record.createDate).toLocaleDateString(),
  }));

  // CSV のエクスポート
  const csv = "\uFEFF" + unparse(csvData, { header: true });
  downloadCSV(csv, `ユーザー一覧_` + new Date().toLocaleDateString());
};

const getType = (userType) =>{
  switch (userType) {
    case 0:
      return "一般スタッフ";
    case 1:
      return "管理スタッフ";
    // case 2:
    //   return "マスター";
    default:
      return "不明な権限";
  }
}

const UsersList = () => {
  const {permissions} = usePermissions();
  if(permissions < 1){
    return;
  }

  const handleRowClick = (id, basePath, record) => {
    const url = `${window.location.origin}/#/${basePath}/show/${id}`;
    const features = 'width=1200,height=800,left=200,top=100,noopener,noreferrer';
    window.open(url, '_blank', features);
    return false;
  };

  const CustomersActions = () => (
  <TopToolbar>
    <CustomCreateButton basePath="/users"/>
    {/* <ExportButton /> */}
  </TopToolbar>
  );


  return (
    <List exporter={customExporter} actions={<CustomersActions />}>
      <Datagrid rowClick={(id, basePath, record) => handleRowClick(id, basePath, record)} bulkActionButtons={false}>
        <TextField source="userName" label="ユーザー名" />
        <TextField source="name" label="名前" />
        <EmailField source="mail" label="メール" />
        <FunctionField
          label="権限"
          render={record => getType(record.userType)}
        />
        <DateField source="createDate" label="登録日" />
      </Datagrid>
    </List>
  )

};

export default UsersList;
